import { render, staticRenderFns } from "./CreditUserDetailsDialogCreditReport.vue?vue&type=template&id=24b9a5e0"
import script from "./CreditUserDetailsDialogCreditReport.vue?vue&type=script&lang=js"
export * from "./CreditUserDetailsDialogCreditReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports